import { WebPaymentTypeEnum } from '../enum/web-payment-type.enum';
import { MerchantPaymentMethodDto } from './merchantPaymentMethod.dto';

export class WebPaymentDto {
  id?: number;
  webPaymentType: WebPaymentTypeEnum;
  webPaymentCode?: string;
  merchantId?: number;
  merchantName?: string;
  referenceId?: number;
  externalMerchantImageUrl?: string;
  merchantPaymentMethods?: MerchantPaymentMethodDto[];
  concept: string;
  date?: Date;
  dueDate?: Date;
  totalAmount: number;
  dueAmount: number;
  currencyCode: string;
  currencySymbol?: string;
  status?: string;
  isPaid: boolean;
  isAuthorized: boolean;
  paymentLink?: string;
  customerInvoiceId?: number;
  merchantInvoiceId?: number;
  paymentDate?: Date;
  orderReference?: string;
  gatewayTxRef?: string;
  gatewayResponse?: string;
  paymentStatus?: string;
  paymentType?: string;
  authorizedAmount?: number;
  settledAmount?: number;
  success?: boolean;
  approvalCode?: string;
  data?: any;
  merchantPaymentMethodId?: number;
  redirect?: any;
  notification?: any;
  response?: any[];
  paymentMethodId?: number;
  paymentMethodDescription?: string;
  lastModifiedUserId?: number;
  bankMIDId: number;
  stripeConnectWasUsed?: boolean;
  stripeConnectAccountId?: string;
  email?: string;
  invoiceName?: string;
  invoiceNumber?: string;
  includedInFirebatch?: boolean;
  includedRefundInFirebatch?: boolean;
  isRefunded?: boolean;
  refundedDate?: Date;    
}
